import $ from 'jquery';

const accordionItemToggle = (el) => {

    $(el).find('.js-accordion-button').on('click', (e) => {
        $(e.currentTarget).next('.accordion-item__content').slideToggle();

        $(e.currentTarget).attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true';
        });
    })

};


export default accordionItemToggle;
